<template>
  <v-layout
    row
    wrap
    class="primaryText--text bg-alert-list mb-2 pa-2"
    :class="[
      {
        'alert-label': !isCheckbox,
        'elevation-4': true,
      },
      indicator(item.status),
    ]"
    @click="$emit('click')"
  >
    <v-btn icon v-show="isCheckbox" @click.stop="toggleCheckboxState">
      <v-icon>
        {{
          isItemSelected
            ? "mdi-checkbox-marked-outline"
            : "mdi-checkbox-blank-outline"
        }}
      </v-icon>
    </v-btn>
    <v-flex xs12 sm6 md6>
      <div class="mb-2">
        <span class="title font-weight-bold">{{ $t(item.code) }}</span>
        <span>
          ({{
            item.name ? item.name : computeId(item.equipment, item.id_details)
          }})</span
        >
      </div>
      <div class="caption truncate font-italic font-weight-light">
        <v-tooltip bottom>
          <template slot="activator">
            {{ $t(item.message) }}
          </template>
          <span>{{ $t(item.message) }}</span>
        </v-tooltip>
      </div>
    </v-flex>
    <v-spacer></v-spacer>
    <v-flex class="d-flex align-center">
      <v-tooltip bottom>
        <template slot="activator">
          <v-icon
            :color="
              activeFilter &&
              activeFilter.severity &&
              activeFilter.severity.color
            "
            >{{
              activeFilter &&
              activeFilter.severity &&
              activeFilter.severity.icon
            }}</v-icon
          >
        </template>
        <span>{{
          activeFilter &&
          activeFilter.severity &&
          $t(activeFilter.severity.text)
        }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template slot="activator">
          <span class="text-capitalize">{{ $t(item.equipment) }}</span>
        </template>
        <span>{{ $t("Equipment") }}</span>
      </v-tooltip>
    </v-flex>
    <v-spacer></v-spacer>
    <v-flex class="text-xs-right">
      <div class="caption extraGrey--text darken-3">
        {{ $t("Created time") }}: {{ item.created_time }}
      </div>
      <div class="caption extraGrey--text darken-3">
        {{ $t("Resolved time") }}:
        {{ item.resolved_time ? item.resolved_time : "NA" }}
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import idHelper from "@/util/id.helper";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    activeFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
    isCheckbox: {
      type: Boolean,
      required: true,
    },
    isSelected: {
      type: Boolean,
    },
  },
  data() {
    return {
      isItemSelected: false,
    };
  },
  mounted() {
    this.isItemSelected = this.isSelected;
  },
  methods: {
    indicator(status) {
      return {
        "alert-label-err": status === "new",
        "alert-label-success": status === "resolved",
        "alert-label-ack": status === "acknowledge",
      };
    },
    computeId(device, id) {
      return id && idHelper[device]
        ? idHelper[device]
            .map((idConfig) => {
              return idConfig.text + "" + id[idConfig.key];
            })
            .join(" - ")
        : id;
    },
    toggleCheckboxState() {
      this.isItemSelected = !this.isItemSelected;
      this.$emit("update-selected", {
        id: this.item.ref_id,
        selected: this.isItemSelected,
      });
    },
  },
  watch: {
    isSelected() {
      this.isItemSelected = this.isSelected;
    },
  },
};
</script>

<style></style>
